export const orderFaqs = [
  {
    question: "Com quanta antecedência devo fazer a encomenda?",
    answer: "A antecedência depende do tipo e da quantidade. Fale connosco pelo WhatsApp para confirmarmos a disponibilidade.",
  },
  {
    question: "Posso escolher diferentes variedades de salgados?",
    answer: "Sim. A equipa indica as variedades disponíveis e ajuda a adequar a seleção ao seu evento.",
  },
  {
    question: "Fazem encomendas para grupos pequenos?",
    answer: "Diga-nos o número aproximado de pessoas. Analisamos consigo a opção mais adequada, sem assumir mínimos não confirmados.",
  },
  {
    question: "O pedido fica confirmado ao enviar o formulário?",
    answer: "Não. O formulário prepara a mensagem; a encomenda só fica confirmada depois de falar diretamente com a equipa no WhatsApp.",
  },
] as const;
